import axios from "axios";
import { BASE_URL } from "../constant/api";

/**
 * Plain, credentialed axios instance — no React context, so anything can import it.
 *
 * Every call that either *receives* the session cookie (signin, complete-signin, signup)
 * or *sends* it must go through this or `useAuthAxios`. Bare `axios` defaults to
 * `withCredentials: false`, which makes the browser silently drop the `Set-Cookie` on the
 * login response: sign-in looks like it succeeded and then bounces straight back to
 * /login. That was the failure mode across all of this app's auth pages, which called
 * bare axios directly rather than the wrapper.
 *
 * Use `useAuthAxios` inside components that want the shared 401/403 handling. Use this one
 * where a hook isn't available, or in auth-context itself (which useAuthAxios depends on).
 *
 * Do NOT use either for the S3 signed-URL uploads — those must not carry credentials.
 */
const sessionAxios = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  // The session is an httpOnly cookie we can't read, so it has to ride along
  // automatically. Without this the browser won't send or store it at all.
  withCredentials: true,
});

export default sessionAxios;
